import { createRootRouteWithContext, HeadContent, Outlet } from '@tanstack/react-router';
import { TanStackRouterDevtools } from '@tanstack/react-router-devtools';
import type { QueryClient } from '@tanstack/react-query';

import { ErrorBoundary } from '@/components/ErrorBoundary/ErrorBoundary';

type RouterContext = {
  queryClient: QueryClient;
};

export const Route = createRootRouteWithContext<RouterContext>()({
  head: () => ({
    meta: [
      {
        title: 'Alopex Health',
      },
    ],
  }),
  component: () => (
    <>
      <HeadContent />
      <ErrorBoundary>
        <Outlet />
      </ErrorBoundary>
      {import.meta.env.VITE_ROUTER_DEVTOOLS === 'true' && (
        <TanStackRouterDevtools position="bottom-left" />
      )}
    </>
  ),
});
